<span sdInViewport (intersected)="onIntersected($event)"></span>
